import { forwardRef } from 'react';
import type { BusinessIconImageProps } from '../businessTypes';

type MorePriceFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const MorePriceFilled = forwardRef<SVGSVGElement, MorePriceFilledProps>(
  ({ size = 24, width, height, alt = '', color = 'currentColor', secondaryColor = '#fff', strokeWidth, style, ...props }, ref) => (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill={color}
      strokeWidth={strokeWidth}
      width={width ?? size}
      height={height ?? size}
      role={alt ? 'img' : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      style={{ color, ...style }}
      {...props}
    >
      <g transform="translate(-5.25 -5.249964) scale(0.71875)">
        <path d="M26.6944 24.0665C26.6944 22.5363 27.6258 21.2058 28.8898 20.5405C28.6902 17.9459 26.5613 15.9501 23.9002 15.9501C21.1726 15.9501 18.9106 18.212 18.9106 20.9397C18.9106 23.6673 21.1726 25.9293 23.9002 25.9293C24.8981 25.9293 25.896 25.5966 26.6279 25.0644V24.0665H26.6944ZM26.6944 30.9189V29.6548C26.6944 29.1891 26.7609 28.79 26.894 28.3908H15.185C15.185 26.4615 13.6549 24.8648 11.659 24.8648V17.4137C13.5884 17.4137 15.185 15.8835 15.185 13.8877H32.6819C32.6819 15.817 34.2121 17.4137 36.2079 17.4137V20.0748H38.736C39.2017 20.0748 39.6008 20.1413 40 20.2744V13.1559C40 11.4927 38.6694 10.1621 37.0062 10.1621H10.9938C9.33056 10.1621 8 11.4927 8 13.1559V29.2557C8 30.9189 9.33056 32.2494 10.9938 32.2494H26.9605C26.8274 31.8503 26.6944 31.3846 26.6944 30.9189ZM39.9335 36.5738C39.9335 37.239 39.2682 37.8378 38.6029 37.8378H30.6195C29.9543 37.8378 29.3555 37.239 29.3555 36.5738V35.3097C29.3555 34.6444 29.9543 34.0457 30.6195 34.0457H38.6694C39.3347 34.0457 39.9335 34.6444 39.9335 35.3097V36.5738ZM39.9335 30.9854C39.9335 31.6507 39.2682 32.2494 38.6029 32.2494H30.6195C29.9543 32.2494 29.3555 31.6507 29.3555 30.9854V29.7214C29.3555 29.0561 29.9543 28.4573 30.6195 28.4573H38.6694C39.3347 28.4573 39.9335 29.0561 39.9335 29.7214V30.9854ZM39.9335 25.3305C39.9335 25.9958 39.2682 26.5945 38.6029 26.5945H30.6195C29.9543 26.5945 29.3555 25.9958 29.3555 25.3305V24.0665C29.3555 23.4012 29.9543 22.8024 30.6195 22.8024H38.6694C39.3347 22.8024 39.9335 23.4012 39.9335 24.0665V25.3305Z" />
      </g>
    </svg>
  ),
);

MorePriceFilled.displayName = 'MorePriceFilled';

export default MorePriceFilled;
